import Logger from '@slickdeals/durango/dist/javascript/utilities/logger';
/** The name of the module */
export const name = 'ValidationRuleSet';
/** The reason this has been broken down to an object is to ensure that rule sets are strictly typed. */
export default class ValidationRuleSet {
    /**
       *
       * @param elementId field elementId (ex. textarea elementId)
       * @param validationRules array of rulesets associated with that field
       */
    constructor(elementId, validationRules, parentElement) {
        const element = parentElement.querySelector(`#${elementId}`);
        if (!element) {
            Logger.error(`${elementId} is not a valid element id`);
        }
        this.elementId = elementId;
        this.validationRules = validationRules;
    }
    /**
     * Returns validationRules
     *
     * @returns {ValidationRules} An array of objects in the form of ValidationRule
     */
    getValidationRules() {
        return this.validationRules;
    }
}
